<script lang="ts" setup>
import { injectMandatory } from "@/vf"
import type { ListState } from "@/vf/components/crud/list/types"

const listState = injectMandatory<ListState>(
    "list-state",
    "VfListRefresh must be used inside an element that provides list-state like VfList.",
)
</script>

<template>
    <button
        type="button"
        class="btn btn-primary btn-shape-rounded btn-shape-rounded-white"
        @click="listState.refresh()"
        :title="$t('crud:button.refresh')"
    >
        <i class="fas fa-rotate" :class="{ 'fa-spin': listState.loading }"></i>
    </button>
</template>
